import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import Review from './containers/Review/Review';
import HotelReview from './containers/ReviewHotel/ReviewHotel';
import Layout from './hoc/Layout/Layout';
import HotelDetail from './components/HotelDetail/HotelDetail';
import Confirmation from './components/Payment/Confirmation/Confirmation';
import HealthCheck from './components/HealthCheck/HealthCheck';

import Header from './components/Header/Header';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faAngleDown, faAngleLeft, faAngleRight, faArrowDown, faUndo, faCaretLeft, faCaretDown, faCaretRight, faClock, faLongArrowAltRight, faTimes, faCalendarAlt, faCheckCircle, faShareAlt, faPrint, faRedo} from '@fortawesome/free-solid-svg-icons';

library.add(faAngleDown, faArrowDown, faUndo, faCaretLeft, faCaretDown, faCaretRight, faClock, faLongArrowAltRight, faTimes, faCalendarAlt, faCheckCircle, faAngleLeft, faAngleRight, faShareAlt, faPrint, faRedo);

// const Reviews = React.lazy(() => import('./containers/Review/Review'));
// const HotelReview = React.lazy(() => import('./containers/ReviewHotel/ReviewHotel'));
// const Layout = React.lazy(() => import('./hoc/Layout/Layout'));
// const HotelDetail = React.lazy(() => import('./components/HotelDetail/HotelDetail'));
// const Confirmation = React.lazy(() => import('./components/Payment/Confirmation/Confirmation.js'));

class App extends Component {
  componentWillMount() {
    const currentTime = new Date().getHours();
    if(currentTime >= 6 && currentTime <= 20) {
      document.getElementById("body").classList.add('light');
      document.getElementById("body").classList.remove('dark');
    } else {
      document.getElementById("body").classList.add('dark');
      document.getElementById("body").classList.remove('light');
    }
  }

  render() {
    return (
      <React.Fragment>
        <Header/>
        <Switch>
          {/* <Suspense fallback={<div>Loading...</div>}>
            <Route path='/confirm' component={Confirmation} />
            <Route path='/hotels/details' component={HotelDetail} />
            <Route path='/reviews' component={Reviews} />
            <Route path='/reviewHotel' component={HotelReview} />
            <Route path='/' component={Layout} />
          </Suspense> */}
          <Route path='/health' component={HealthCheck} />
          <Route path='/confirm' component={Confirmation} />
          <Route path='/hotels/details' component={HotelDetail} />
          <Route path='/reviews' component={Review} />
          <Route path='/reviewHotel' component={HotelReview} />
          <Route path='/' component={Layout} />
        </Switch>
      </React.Fragment>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js